import { z } from 'zod'

export namespace novuFeature {
    type TriggerPayloadMap = {
        welcome: { collected: boolean }
        'buy-subscription': { subscription: string }
        'buy-gold': {}
        'retro-drop-available': {}
        'collect-toy': {}
        'subsription-pay-error': {}
        'subscription-is-running-out': {}
        'low-balance': {}
        'new-offer': {
            imageid: string
            toyname: string
            price: string
            currency: string
            unsubscribe_url: string
        }
        'in-app-notification': {}
        'test-notification': {}
        'artist-application-aproved': {}
        'artist-application-rejected': {}
        'artist-application-recieved': {}
        'toy-application-approved': {}
        'toy-application-rejected': {}
        'toy-application-recieved': {}
        'set-application-approved': {}
        'set-application-rejected': {}
        'set-application-recieved': {}
    }

    export type Trigger = keyof typeof TriggerPayloadMap

    export type Event<T extends Trigger> = {
        trigger: T
        to: {
            id: string
            email: string
        }
        payload: TriggerPayloadMap[T]
    }

    const TriggerPayloadMap = {
        welcome: z.object({ collected: z.boolean() }),
        'buy-subscription': z.object({ subscription: z.string() }),
        'buy-gold': z.object({}),
        'retro-drop-available': z.object({}),
        'collect-toy': z.object({}),
        'subsription-pay-error': z.object({}),
        'subscription-is-running-out': z.object({}),
        'low-balance': z.object({}),
        'new-offer': z.object({
            imageid: z.string(),
            toyname: z.string(),
            price: z.string(),
            currency: z.string(),
            unsubscribe_url: z.string()
        }),
        'in-app-notification': z.object({}),
        'test-notification': z.object({}),
        'artist-application-aproved': z.object({}),
        'artist-application-rejected': z.object({}),
        'artist-application-recieved': z.object({}),
        'toy-application-approved': z.object({}),
        'toy-application-rejected': z.object({}),
        'toy-application-recieved': z.object({}),
        'set-application-approved': z.object({}),
        'set-application-rejected': z.object({}),
        'set-application-recieved': z.object({})
    } as const

    export const NovuEvent = {
        Event: <T extends keyof typeof TriggerPayloadMap>(trigger: T) =>
            z.object({
                trigger: z.literal(trigger),
                to: z.object({
                    id: z.string(),
                    email: z.string()
                }),
                payload: TriggerPayloadMap[trigger]
            })
    }
}
